function normalizeBasePathValue(raw: string | undefined): string {
  const trimmed = (raw ?? '').trim();
  if (!trimmed || trimmed === '/') return '';
  const withLeading = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return withLeading.replace(/\/+$/, '');
}

export function readWebBasePath(): string {
  const raw =
    (typeof process !== 'undefined' ? process.env.OD_WEB_BASE_PATH : undefined) ??
    (typeof process !== 'undefined' ? process.env.NEXT_PUBLIC_OD_BASE_PATH : undefined) ??
    '';
  return normalizeBasePathValue(raw);
}

export function withWebBasePath(path: string): string {
  if (!path.startsWith('/')) return path;
  const base = readWebBasePath();
  if (!base) return path;
  if (path === base || path.startsWith(`${base}/`)) return path;
  return `${base}${path}`;
}

export function stripWebBasePath(pathname: string): string {
  const base = readWebBasePath();
  if (!base) return pathname;
  if (pathname === base) return '/';
  if (pathname.startsWith(`${base}/`)) {
    const stripped = pathname.slice(base.length);
    return stripped.length === 0 ? '/' : stripped;
  }
  return pathname;
}

export function isDaemonProxyPathname(pathname: string): boolean {
  const stripped = stripWebBasePath(pathname);
  return (
    stripped === '/api' ||
    stripped.startsWith('/api/') ||
    stripped === '/artifacts' ||
    stripped.startsWith('/artifacts/') ||
    stripped === '/frames' ||
    stripped.startsWith('/frames/')
  );
}

/**
 * Browser fetches owned by this web app and therefore required to stay under
 * the configured deployment base path. Next's development overlay currently
 * emits root-relative /__nextjs_* requests even when basePath is configured,
 * so keep its private runtime namespace here alongside the app proxy paths.
 */
export function isWebOwnedRequestPathname(pathname: string): boolean {
  const stripped = stripWebBasePath(pathname);
  return (
    isDaemonProxyPathname(stripped) ||
    stripped === '/_next' ||
    stripped.startsWith('/_next/') ||
    stripped === '/__nextjs' ||
    stripped.startsWith('/__nextjs_') ||
    stripped.startsWith('/__nextjs/')
  );
}
